import { action, makeObservable, observable } from "mobx";
import { SmartCard } from "core/models/primary-smart-card";
import { PackageInfo, Service } from "core/services/cef/customer-account.service";
import { BaseStore } from "./base.store";

export type Bouquet = BouquetPackage & {
    packages: Array<BouquetPackage>;
}

export type BouquetPackage = {
    name: string;
    tvPoints: number;
}

export type Subscription = {
    status: string,
    packageType: string,
    totalTV: string
};

export type SubscriptionParent = {
    status: string,
    packageType: string,
    packages: Service[]
}

export type AgreementSubscription = {
    id: number,
    name: string
    tvPoints: number,
    location: string,
    status: string,
    subscriptions: SubscriptionParent[]
}

class SubscriptionStore extends BaseStore {
    subscriptions?: Subscription[];
    smartcardNumbers: string[] = [];
    agreementPackages?: AgreementSubscription[];
    packages: PackageInfo[] = [];

    primarySmartCard: SmartCard | undefined = undefined;

    bouquets: Bouquet[] | undefined;

    constructor() {
        super();

        makeObservable(this, {
            subscriptions: observable,
            smartcardNumbers: observable,
            agreementPackages: observable,
            packages: observable,
            primarySmartCard: observable,
            bouquets: observable,
            updateAgreements: action,
            updateAgreementPackages: action,
            updateSmartcardNumbers: action,
            updateSubscriptions: action,
            updatePrimarySmartCard: action,
            updatePackages: action
        });
    }

    reset() {
        super.reset();

        this.subscriptions = undefined;
        this.agreementPackages = undefined;
        this.packages = [];
    }

    updateAgreements(value?: Bouquet[]) {
        this.bouquets = value;
    }

    updateAgreementPackages(value?: AgreementSubscription[]) {
        this.agreementPackages = value;
    }

    updateSmartcardNumbers(value: string[]) {
        value.sort();
        this.smartcardNumbers = value;
    }

    updateSubscriptions(value?: Subscription[]) {
        this.subscriptions = value;
    }

    updatePrimarySmartCard(value: SmartCard | undefined) {
        this.primarySmartCard = value;
    }

    updatePackages(value: PackageInfo[]) {
        this.packages = value;
    }

    updateHasError(value: boolean, message = "An error has occurred retrieving subscriptions") {
        this.hasError = value;
        this.errorMessage = message;
    }
}

export default SubscriptionStore;
